import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { CDHCISection } from "@/components/CDHCISection";
import { About } from "@/components/About";
import { Careers } from "@/components/Careers";
import { ContactBooking } from "@/components/ContactBooking";
import { Footer } from "@/components/Footer";
import Privacy from "@/pages/Privacy";

const Home = () => (
  <div data-testid="home-page">
    <Navbar />
    <main>
      <Hero />
      <Services />
      <About />
      <CDHCISection />
      <Process />
      <Careers />
      <ContactBooking />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
